'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useState, useMemo, useEffect } from 'react';
import LabeledTextInput from 'components/consumer/LabeledTextInput';
import ValidationError from 'components/consumer/ValidationError';
import useAdvancedSearchContext from '../../hooks/useAdvancedSearchContext';
const MIN_ALLOWED = 1;
const MAX_ALLOWED = 300;
const WidthRangeFilter = t0 => {
  const $ = _c(34);
  const {
    showTitle: t1
  } = t0;
  const showTitle = t1 === undefined ? false : t1;
  const {
    minWidth,
    maxWidth,
    handleWidthChange
  } = useAdvancedSearchContext();
  const [minimum, setMinimum] = useState(minWidth ?? "");
  const [maximum, setMaximum] = useState(maxWidth ?? "");
  let t2;
  let t3;
  if ($[0] !== minWidth) {
    t2 = () => {
      setMinimum(minWidth ?? "");
    };
    t3 = [minWidth];
    $[0] = minWidth;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[3] !== maxWidth) {
    t4 = () => {
      setMaximum(maxWidth ?? "");
    };
    t5 = [maxWidth];
    $[3] = maxWidth;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  useEffect(t4, t5);
  const minNum = minimum ? parseInt(minimum, 10) : NaN;
  const maxNum = maximum ? parseInt(maximum, 10) : NaN;
  let t6;
  bb0: {
    if (!minimum) {
      t6 = "";
      break bb0;
    }
    if (Number.isNaN(minNum)) {
      t6 = "Please enter a valid number";
      break bb0;
    }
    if (minNum < MIN_ALLOWED) {
      t6 = `Minimum value cannot be less than ${MIN_ALLOWED}`;
      break bb0;
    }
    if (minNum > MAX_ALLOWED) {
      t6 = `Minimum value cannot be more than ${MAX_ALLOWED}`;
      break bb0;
    }
    if (!Number.isNaN(maxNum) && minNum > maxNum) {
      t6 = `Minimum value cannot be greater than ${maxNum}`;
      break bb0;
    }
    t6 = "";
  }
  const minError = t6;
  let t7;
  bb1: {
    if (!maximum) {
      t7 = "";
      break bb1;
    }
    if (Number.isNaN(maxNum)) {
      t7 = "Please enter a valid number";
      break bb1;
    }
    if (maxNum < MIN_ALLOWED) {
      t7 = `Maximum value cannot be less than ${MIN_ALLOWED}`;
      break bb1;
    }
    if (maxNum > MAX_ALLOWED) {
      t7 = `Maximum value cannot be more than ${MAX_ALLOWED}`;
      break bb1;
    }
    if (!Number.isNaN(minNum) && maxNum < minNum) {
      t7 = `Maximum value cannot be less than ${minNum}`;
      break bb1;
    }
    t7 = "";
  }
  const maxError = t7;
  let t8;
  let t9;
  if ($[6] !== handleWidthChange || $[7] !== maxError || $[8] !== maximum || $[9] !== minError || $[10] !== minimum) {
    t8 = () => {
      const hasError = minError || maxError;
      if (!hasError) {
        handleWidthChange?.(minimum, maximum);
      }
    };
    t9 = [minimum, maximum, minError, maxError, handleWidthChange];
    $[6] = handleWidthChange;
    $[7] = maxError;
    $[8] = maximum;
    $[9] = minError;
    $[10] = minimum;
    $[11] = t8;
    $[12] = t9;
  } else {
    t8 = $[11];
    t9 = $[12];
  }
  useEffect(t8, t9);
  let t10;
  if ($[13] !== maxError || $[14] !== minError) {
    t10 = {
      min: minError,
      max: maxError
    };
    $[13] = maxError;
    $[14] = minError;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const widthRangeError = t10;
  let t11;
  if ($[16] !== showTitle) {
    t11 = showTitle && <h3 className="text-base font-bold mb-2">Width</h3>;
    $[16] = showTitle;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = event => {
      setMinimum(event?.target?.value);
    };
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== minimum) {
    t13 = <LabeledTextInput variant="range-filter" type="number" name="min" data-xc="min-width-filter-field" label="Min" placeholder="Min" id="min-width" className="mr-0 xl:mr-[5px]" onChange={t12} value={minimum} postfixText="in." noMargin={true} />;
    $[19] = minimum;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = event_0 => {
      setMaximum(event_0?.target?.value);
    };
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== maximum) {
    t15 = <LabeledTextInput variant="range-filter" type="number" name="max" data-xc="max-width-filter-field" label="Max" placeholder="Max" id="max-width" className="ml-0 xl:ml-[5px]" onChange={t14} value={maximum} postfixText="in." noMargin={true} />;
    $[22] = maximum;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t13 || $[25] !== t15) {
    t16 = <div className="flex flex-row items-center flex-nowrap md:flex-wrap xl:flex-nowrap justify-start xl:justify-between gap-3 xl:gap-0">{t13}{t15}</div>;
    $[24] = t13;
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== widthRangeError.max || $[28] !== widthRangeError.min) {
    t17 = (widthRangeError.max || widthRangeError.min) && <ValidationError block={true}>{widthRangeError.min || widthRangeError.max}</ValidationError>;
    $[27] = widthRangeError.max;
    $[28] = widthRangeError.min;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== t11 || $[31] !== t16 || $[32] !== t17) {
    t18 = <div className="flex flex-col">{t11}{t16}{t17}</div>;
    $[30] = t11;
    $[31] = t16;
    $[32] = t17;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  return t18;
};
export default WidthRangeFilter;